var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSummaryDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15243_43939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1431 1.71362H13.7146M23.1431 6.85648H13.7146M23.1431 11.9993H13.7146M23.1431 22.2851H13.7146M23.1431 17.1422H13.7146M0.857422 2.57077V9.42791C0.857422 9.90129 1.24118 10.2851 1.71456 10.2851H8.57171C9.04509 10.2851 9.42885 9.90129 9.42885 9.42791V2.57077C9.42885 2.09738 9.04509 1.71362 8.57171 1.71362H1.71456C1.24118 1.71362 0.857422 2.09738 0.857422 2.57077ZM0.857422 14.5708V21.4279C0.857422 21.9012 1.24118 22.2851 1.71456 22.2851H8.57171C9.04509 22.2851 9.42885 21.9012 9.42885 21.4279V14.5708C9.42885 14.0974 9.04509 13.7136 8.57171 13.7136H1.71456C1.24118 13.7136 0.857422 14.0974 0.857422 14.5708Z",
    stroke: "#252938",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15243_43939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSummaryDarkblue);
export default __webpack_public_path__ + "static/media/Account-summary-darkblue.87f10215.svg";
export { ForwardRef as ReactComponent };